module.exports = __webpack_public_path__ + "static/media/Vivek.e5e32e66.png";